export enum EN_东风_BRANCH_NAME {
  本厂股份 = '东风本厂股份',
  本厂易捷特 = '东风本厂易捷特',
  本厂商用车 = '东风本厂商用车',
  本厂乘用车 = '东风本厂乘用车',
  神龙 = '东风神龙',
  日产 = '东风日产',
  本田 = '东风本田',
}
